package com.sddamico.swigmore.ds.poll

import androidx.compose.runtime.Composable
import com.sddamico.swigmore.ds.SwColor
import com.sddamico.swigmore.ds.SwType
import com.sddamico.swigmore.ds.core.Card
import com.sddamico.swigmore.ds.core.CardVariant
import com.sddamico.swigmore.ds.css
import com.sddamico.swigmore.ds.typeCaps
import com.sddamico.swigmore.models.PollStanding
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.toAttrs
import org.jetbrains.compose.web.dom.Div
import org.jetbrains.compose.web.dom.Span
import org.jetbrains.compose.web.dom.Text

/** A team's poll standing in each listed week ([PollStanding.Unranked] renders as —). */
data class RankHistoryRow(val team: String, val weeks: List<PollStanding>)

/** Season rank history grid from the Record Book. Scrolls horizontally on narrow screens. */
@Composable
fun RankHistoryTable(weekLabels: List<String>, rows: List<RankHistoryRow>, modifier: Modifier = Modifier) {
  val columns = "minmax(200px,1fr) repeat(${weekLabels.size},80px)"
  Card(modifier.css("overflow" to "auto"), variant = CardVariant.Field, padding = "0") {
    Div(attrs = Modifier.css("min-width" to "${200 + 80 * weekLabels.size + 40}px").toAttrs()) {
      Div(
        attrs = Modifier.typeCaps("9px", ".18em")
          .css("display" to "grid", "grid-template-columns" to columns, "padding" to "10px 16px",
            "color" to SwColor.gold, "border-bottom" to "1px solid ${SwColor.hairline}")
          .toAttrs()
      ) {
        Span { Text("Team") }
        weekLabels.forEach { Span(attrs = Modifier.css("text-align" to "center").toAttrs()) { Text(it) } }
      }
      rows.forEach { row ->
        Div(
          attrs = Modifier.css("display" to "grid", "grid-template-columns" to columns, "align-items" to "center",
            "padding" to "8px 16px", "border-top" to "1px solid rgba(239,229,201,.08)").toAttrs()
        ) {
          Span(attrs = Modifier.typeCaps("13px", "0").toAttrs()) { Text(row.team) }
          row.weeks.forEach { standing ->
            val (v, size, color) = when (standing) {
              is PollStanding.Ranked -> Triple(standing.rank.toString(), "20px", SwColor.cream)
              PollStanding.ReceivingVotes -> Triple("RV", "12px", SwColor.gold)
              PollStanding.Unranked -> Triple("—", "12px", SwColor.textFaint)
            }
            Span(attrs = Modifier.css("text-align" to "center", "font" to "400 $size ${SwType.display}", "color" to color).toAttrs()) { Text(v) }
          }
        }
      }
    }
  }
}
